(() => {
  const models = [
    'iPhone 7', 'iPhone 7 Plus', 'iPhone 8', 'iPhone 8 Plus',
    'iPhone SE (2020)', 'iPhone SE (2022)',
    'iPhone X', 'iPhone XR', 'iPhone XS', 'iPhone XS Max',
    'iPhone 11', 'iPhone 11 Pro', 'iPhone 11 Pro Max',
    'iPhone 12', 'iPhone 12 mini', 'iPhone 12 Pro', 'iPhone 12 Pro Max',
    'iPhone 13', 'iPhone 13 mini', 'iPhone 13 Pro', 'iPhone 13 Pro Max',
    'iPhone 14', 'iPhone 14 Plus', 'iPhone 14 Pro', 'iPhone 14 Pro Max',
    'iPhone 15', 'iPhone 15 Plus', 'iPhone 15 Pro', 'iPhone 15 Pro Max',
    'iPhone 16', 'iPhone 16e', 'iPhone 16 Plus', 'iPhone 16 Pro', 'iPhone 16 Pro Max',
    'iPhone 17', 'iPhone 17e', 'iPhone 17 Pro', 'iPhone 17 Pro Max',
    'iPhone Air',
    'iPhone 18', 'iPhone 18 Pro', 'iPhone 18 Pro Max'
  ];

  const normalize = (value) => String(value || '')
    .normalize('NFKC')
    .trim()
    .toLowerCase()
    .replace(/[–—_-]+/g, ' ')
    .replace(/^apple\s+/, '')
    .replace(/^iphone(?=\d|air|se)/, 'iphone ')
    .replace(/\bpro\s*max\b/g, 'pro max')
    .replace(/\s+/g, ' ');

  const modelByQuery = new Map(models.map((model) => [normalize(model), model]));
  const exactModel = (query) => modelByQuery.get(normalize(query));
  const modelUrl = (model) =>
    `/collections/all?filter.p.m.tovynx.compatible_models=${encodeURIComponent(model)}`;

  const modelPosition = new Map(models.map((model, index) => [normalize(model), index]));

  const sortByModel = (items, valueOf) =>
    items.slice().sort((a, b) => {
      const aRank = modelPosition.get(normalize(valueOf(a)));
      const bRank = modelPosition.get(normalize(valueOf(b)));
      return (aRank ?? 999) - (bRank ?? 999);
    });

  const orderModelControls = () => {
    document.querySelectorAll('[data-tvx-model-select]').forEach((select) => {
      const options = Array.from(select.options);
      const placeholder = options.filter((option) => !option.value);
      const modelsOnly = sortByModel(options.filter((option) => option.value), (option) => option.value);
      const desired = placeholder.concat(modelsOnly);
      if (desired.some((option, index) => select.options[index] !== option)) {
        desired.forEach((option) => select.appendChild(option));
      }
    });

    const modelInputs = document.querySelectorAll('input[name="filter.p.m.tovynx.compatible_models"]');
    const lists = new Set(Array.from(modelInputs).map((input) => input.closest('ul')).filter(Boolean));
    lists.forEach((list) => {
      const rows = Array.from(list.children).filter((row) => !row.classList.contains('link-more'));
      const more = Array.from(list.children).filter((row) => row.classList.contains('link-more'));
      const desired = sortByModel(rows, (row) => row.querySelector('input')?.value || '');
      if (desired.some((row, index) => rows[index] !== row)) {
        desired.concat(more).forEach((row) => list.appendChild(row));
      }
    });

    document.querySelectorAll('form.f8fl fieldset').forEach((fieldset) => {
      const headings = Array.from(fieldset.children).filter((item) => item.matches('h4[data-filter-toggle]'));
      const groups = headings.map((heading, index) => {
        const body = heading.nextElementSibling;
        const input = body?.querySelector('input[name]');
        const param = input?.name || '';
        let rank = 4;
        if (param === 'filter.p.m.tovynx.compatible_models') rank = 0;
        else if (/^filter\.v\.option\.(colour|color)$/i.test(param)) rank = 1;
        else if (param === 'filter.v.availability') rank = 2;
        else if (/price/i.test(param)) rank = 3;
        return { heading, body, rank, index };
      });
      const desired = groups.slice().sort((a, b) => a.rank - b.rank || a.index - b.index);
      if (!desired.some((group, index) => groups[index] !== group)) return;
      const marker = document.createComment('tovynx-filter-order');
      fieldset.insertBefore(marker, headings[0]);
      desired.forEach(({ heading, body }) => {
        fieldset.insertBefore(heading, marker);
        if (body) fieldset.insertBefore(body, marker);
      });
      marker.remove();
    });
  };

  const isSearchForm = (form) => {
    if (!(form instanceof HTMLFormElement) || !form.querySelector('input[name="q"]')) return false;
    try {
      return new URL(form.action || '/search', window.location.origin).pathname.replace(/\/+$/, '') === '/search';
    } catch (error) {
      return false;
    }
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!isSearchForm(form)) return;
    const model = exactModel(form.querySelector('input[name="q"]').value);
    if (!model) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(modelUrl(model));
  }, true);

  if (window.location.pathname.replace(/\/+$/, '') === '/search') {
    const model = exactModel(new URLSearchParams(window.location.search).get('q'));
    if (model) window.location.replace(modelUrl(model));
  }

  orderModelControls();

  let filterOrderScheduled = false;
  new MutationObserver(() => {
    if (filterOrderScheduled) return;
    filterOrderScheduled = true;
    requestAnimationFrame(() => {
      filterOrderScheduled = false;
      orderModelControls();
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
